import { Component } from '@angular/core'

@Component({
  selector: 'app-catalogue-loader',
  template: `<div class="column is-12-desktop m-t-xl">
    <div class="lc lc--accordion">
      <div></div>
      <div></div>
    </div>
    <div class="lc lc--tool">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="lc lc--tool">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="lc lc--tool">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>`
})
export class ToolsCatalogueLoaderComponent {}
